import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useRef, useState } from 'react';
import SFVisibilityIcon from '../icons/sf-visiblity-icon';
import SFVisibilityOffIcon from '../icons/sf-visiblity-off-icon';
import { SFPalette } from '@/lib/color';

export default function PasswordTextField({
  error,
  placeholder,
  helperText,
  InputProps,
  ...props
}: {
  error?: boolean;
  placeholder?: string;
  helperText?: string;
  InputProps?: TextFieldProps['InputProps'];
} & TextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const ref = useRef<HTMLInputElement>(null); // useRef를 이용하여 password TextField에 대한 참조를 만듭니다.

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
    setTimeout(() => {
      ref.current?.focus();
      ref.current?.setSelectionRange(ref.current.value.length, ref.current.value.length);
    }, 50); // 아이콘 클릭 시 password TextField에 포커스를 줍니다.
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault();

  return (
    <TextField
      fullWidth
      inputRef={ref}
      type={showPassword ? 'text' : 'password'}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
              {showPassword ? <SFVisibilityIcon /> : <SFVisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      FormHelperTextProps={{
        style: {
          color: error ? 'red' : props.value ? SFPalette.shuffleColor2 : SFPalette.lightGrey2,
        },
      }}
      {...props}
    />
  );
}
